import { render, staticRenderFns } from "./RequestedLabs.vue?vue&type=template&id=406d071e&"
import script from "./RequestedLabs.vue?vue&type=script&lang=js&"
export * from "./RequestedLabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports